import type { SearchIndex } from '~/modules/search';
import type { ConstantLengthArray } from '@utils-rocco/types';

export const SEARCH_AGGREGATE_API = '/actions/search/aggregate';

export const DEFAULT_PAGE_SIZE = 40;

interface SearchCategoryConfig {
    children: string;
    mobileName?: string;
    category?: 'products' | 'projects' | 'professionals' | 'articles';
    index?: SearchIndex;
    categoryLink?: string;
}

export const SEARCH_CATEGORIES: ConstantLengthArray<SearchCategoryConfig, 5> = [
    {
        children: 'All',
        categoryLink: undefined,
    },
    {
        children: 'Products',
        category: 'products',
        index: 'product',
        categoryLink: '/products',
    },
    {
        children: 'Projects',
        category: 'projects',
        index: 'project',
        categoryLink: '/projects',
    },
    {
        children: 'Professionals',
        mobileName: 'Pros',
        category: 'professionals',
        index: 'professional',
        categoryLink: '/professionals',
    },
    {
        children: 'Articles',
        category: 'articles',
        index: 'blogpost',
        categoryLink: '/articles',
    },
];
